export enum JobTitle {
  ACM = 'ACM',
  ADMINISTRATOR = 'ADMINISTRATOR',
  CABIN_CREW = 'CABIN_CREW',
  CCM = 'CCM',
  COMM = 'COMM',
  COPILOT = 'COPILOT',
  DEADHEAD = 'DEADHEAD',
  DISPATCHER = 'DISPATCHER',
  GH = 'GH',
  GROUND_HANDLER = 'GROUND_HANDLER',
  GUEST = 'GUEST',
  MAINTENANCE_CREW = 'MAINTENANCE_CREW',
  PILOT = 'PILOT',
  SCCM = 'SCCM',
  UNKNOWN = 'UNKNOWN',
}
